export default __webpack_public_path__ + "static/media/victoria_nails_007.bbe85ce6.jpg";